export enum StorageKey {
  Token = 'token',
  RefreshToken = 'refresh_token',
  DeviceId = 'device_id'
}
